export type HitsContext = Record<string, unknown>;

let _ctx: HitsContext = {};
let _autoSessionId: string | null = null;

export function setHitsContext(ctx: HitsContext): void {
  _ctx = { ..._ctx, ...ctx };
}

export function getHitsContext(): HitsContext {
  return { ..._ctx };
}

export function clearHitsContext(): void {
  _ctx = {};
}

function uuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof (crypto as Crypto).randomUUID === 'function') {
    return (crypto as Crypto).randomUUID();
  }
  // RFC4122 v4 fallback for environments without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Lazy module-scope session id. Format mirrors the existing gokwik hits
 * client: `se` prefix + uuid. Generated once per page lifecycle; same value
 * for every hit until page navigation.
 */
export function getAutoSessionId(): string {
  if (_autoSessionId === null) {
    _autoSessionId = 'se' + uuidV4();
  }
  return _autoSessionId;
}

export function __resetAutoSessionIdForTests(): void {
  _autoSessionId = null;
}
